export const normalizeForMatch = (str: string | null | undefined): string =>
  (str ?? '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s]/g, '');
